import { LIST_BOATS, UPDATE_BOAT_RATING } from '../actions/types';

const INITIAL_STATE = [];

export default (state = [], action) => {
  switch (action.type) {
    case 'LIST_BOATS':
      return action.payload;
    case UPDATE_BOAT_RATING:
      const { boatId, ratingData } = action.payload;
      return state.map(boat => {
        if (boat.uid === boatId) {
          return { ...boat, ...ratingData };
        }
        return boat;
      });      
    default:
      return state;
  }
};
